// src/utils/imageCache.ts - Simple image preloader utility
export const preloadImages = (imageUrls: string[]): Promise<void[]> => {
  const promises = imageUrls.map(url => {
    return new Promise<void>((resolve, reject) => {
      const img = new Image();
      img.onload = () => resolve();
      img.onerror = () => {
        console.warn(`Failed to preload image: ${url}`);
        resolve(); // Don't fail the whole batch for one bad image
      };
      img.src = url;
    });
  });
  
  return Promise.all(promises);
};

// Helper to extract unique image URLs from cards
export const getCardImageUrls = (cards: { image_url: string }[]): string[] => {
  const uniqueUrls = new Set(cards.map(card => card.image_url));
  return Array.from(uniqueUrls);
};